import React from "react";

import TabsNavigation from "../TabsNavigation/TabsNavigation";
import TabContent from "./TabContent/TabContent";

const ViewMode = (props) => {
  return (
    <div className="template-wrapper container-fluid">
      {/* <TemplateHeader /> */}
      <TabsNavigation
        changeTabHandler={props.changeTabHandler}
        content={props.content}
        contentLength={props.content.length}
        activeTab={props.activeTab}
        toggleEditHandler={props.toggleEditHandler}
        toggleViewHandler={props.toggleViewHandler}
        ViewMode={true}
        editView={props.editView}
        hideIcon = {props.hideIcon}
      />
      <div className="row tab-content-wrapper mt-6 pl-10" id="style-2">
        <form>
          {props.content.map((tab) => {
            if (tab.tabId === props.activeTab) {
              if (tab.tabSections) {
                return (
                  <TabContent key={tab.tabId} sections={tab.tabSections} />
                );
              }
            }
            return true;
          })}
        </form>
      </div>
    </div>
  );
};

export default ViewMode;
